/* ═══ EL PAGINADOR DE LAS 52 RESEÑAS ══════════════════════════════════════
   52 reseñas de corrido son 8 500 px de scroll. Se parten en páginas de 12.

   🔴 LAS 52 SE SIRVEN EN EL HTML, SIEMPRE. La paginación la hace este archivo
   ESCONDIENDO, no pidiendo. Dos razones y las dos importan:
     · **Google las lee todas.** Una página de reseñas que carga sus reseñas por
       JavaScript es una página de reseñas invisible para el buscador, que es
       justo para lo que sirve tener 52.
     · **Sin JS se ven las 52**, no cero. El estado por defecto del marcado es
       «todo visible»; este archivo sólo lo recorta. Al revés —esconder por CSS
       y mostrar por JS— un fallo del script deja la página vacía.

   Por eso el `<nav>` nace con `hidden` y este archivo se lo quita: si el script
   no corre, no hay botones de página que no llevan a ningún lado.               */
(() => {
  const muro = document.querySelector('.muro-52');
  const pager = document.querySelector('.pager-52');
  if (!muro || !pager) return;

  const voces = [...muro.querySelectorAll('.voz')];
  const POR = Number(muro.dataset.porPagina) || 12;
  const total = Math.ceil(voces.length / POR);
  if (total < 2) return;

  /* La cabecera de la sección, para volver a ella al cambiar de página. Se
     busca desde el muro hacia arriba: la página no tiene id propio y anclar a
     `#resenas` la mandaría al apartado de la FICHA si algún día conviven. */
  const arriba = muro.closest('.seccion') || muro;

  let actual = 1;

  function pinta(n, mover) {
    actual = Math.min(Math.max(1, n), total);
    voces.forEach((v, i) => {
      const dentro = i >= (actual - 1) * POR && i < actual * POR;
      v.hidden = !dentro;
    });
    botones();
    /* Sólo se sube al cambiar de página a mano. Al cargar NO: robarle el scroll
       a alguien que acaba de llegar es de las cosas que más molestan. */
    if (mover) {
      arriba.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto' : 'smooth',
        block: 'start',
      });
    }
  }

  function botones() {
    pager.innerHTML = '';
    const b = (txt, n, extra) => {
      const el = document.createElement('button');
      el.type = 'button';
      el.textContent = txt;
      if (extra) el.className = extra;
      if (n === actual) {
        el.setAttribute('aria-current', 'page');
        el.classList.add('aqui');
      }
      if (n < 1 || n > total) el.disabled = true;
      el.addEventListener('click', () => pinta(n, true));
      pager.appendChild(el);
    };
    b('←', actual - 1, 'flecha');
    for (let i = 1; i <= total; i++) b(String(i), i);
    b('→', actual + 1, 'flecha');

    const cuenta = document.createElement('p');
    const desde = (actual - 1) * POR + 1;
    const hasta = Math.min(actual * POR, voces.length);
    cuenta.className = 'pager-cuenta';
    cuenta.textContent = `${desde}–${hasta} de ${voces.length}`;
    pager.appendChild(cuenta);
  }

  pager.hidden = false;
  pinta(1, false);
})();
